"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogAlert = exports.alertDialogType = void 0;
const DialogBase_1 = require("./DialogBase");
exports.alertDialogType = "ALERT";
class DialogAlert extends DialogBase_1.DialogBase {
    constructor(data) {
        super(exports.alertDialogType);
        this.type = exports.alertDialogType;
        this.close = () => {
            this.isOpen = false;
            if (this.postClose) {
                this.postClose();
            }
        };
        this.buttonLabel = data.buttonLabel;
        this.message = data.message;
        this.title = data.title;
        this.postClose = data.onClose;
        if (data.preventOutsideDismiss !== undefined) {
            this.preventOutsideDismiss = data.preventOutsideDismiss;
        }
    }
}
exports.DialogAlert = DialogAlert;
